import {useContext} from "react";
import {OrgDataContext, OrgDataProviderContext} from "../../context/orgData";
import * as constants from 'common/constants';

function isTalos(orgData: OrgDataProviderContext) {
    return orgData.getOrgIDByType('customer') === constants.organization.TALOS_ID;
}

export function useFlightEditorFeatureFlags() {

    const orgData = useContext(OrgDataContext);

    const flags = {
        customsPrintoutEnabled: true
    }

    if (isTalos(orgData)) {
        // Hide customs printout feature for Talos only
        flags.customsPrintoutEnabled = false;
    }

    return flags;
}